import { render, staticRenderFns } from "./AssignPermissionsToRole.vue?vue&type=template&id=86296450&"
import script from "./AssignPermissionsToRole.vue?vue&type=script&lang=js&"
export * from "./AssignPermissionsToRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports